export default "__VITE_ASSET__CN4j1fEF__"